/**
 * Reusable labelled field wrapper for form rows in node editing panels.
 */
import React from 'react';

interface FieldProps {
    label: string;
    children: React.ReactNode;
    style?: React.CSSProperties;
}

export default function Field({ label, children, style }: FieldProps) {
    return (
        <div className='field-group' style={style}>
            <label className='nodepanel-label'>{label}</label>
            {children}
        </div>
    );
}
